import { createApp } from 'vue'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import App from '@/App.vue'
import router from '@/router'
import '@/style/main.scss'
import vvConfigs from '@/validate/VeeValidateConfigs'
import VueTelInput from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import i18n from './locales/I18n'
import StoreUtil from './stores/StoreUtil'

vvConfigs()

dayjs.extend(isBetween)
StoreUtil.provideAllStore(
  createApp(App)
    .use(router)
    .use(i18n)
    .use(VueTelInput, { mode: 'international' }),
).mount('#app')
